module.exports = __webpack_public_path__ + "media/components/country-flag/static/cefta-c432b1098d7755588ae4853b883854bb.svg";